export default __webpack_public_path__ + "static/comment-f7643c1b08098402bb4eefdc83e6f7ef.jpg";